import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/dashboard/leads-engine')({
  beforeLoad: () => {
    throw redirect({
      to: '/dashboard/settings/leads',
      search: { tab: 'test' },
      replace: true,
    });
  },
});
